module.exports = __webpack_public_path__ + "media/images/game_icon/zh-cn/AB1511-e960f72c4cdc8f1c5c95fe01f6743f3c.png";